
//#region import libraries
import React from "react"
//bootstrap
import { Col, Container, Form, Row } from "react-bootstrap"
//styles
import "./survey-answers.css"
import { Colors } from "_styles"
//icons
import { FaStar } from "react-icons/fa"
//#endregion
import PRMLogo from "../../../assets/images/PRM-Logo-PNG/logo.png"
import { translate } from "./surveys-utils"

// constants
const scaleArray10 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const scaleArray5 = [1, 2, 3, 4, 5];

//#region custom component
{/* render UI for question body*/ }
const QuestionContent = ({ type, options, questionId, answers, handleChange, lang, handleCommentChange, handleCheckboxChange, items, handleMatrixChange, scaleLabels, starsCount }) => {
    {/*render Rating question*/ }
    if (type == "rating") {
        // Use starsCount if available, fallback to options length for backward compatibility
        const starCount = starsCount || options?.length || 5;
        const starsArray = Array.from({ length: starCount }, (_, i) => i + 1);
        const selectedValue = parseInt(answers[questionId]) || 0;
        
        return (
            <Form>
                <div className="d-flex justify-content-center align-items-center gap-3">
                    {starsArray.map((starNum) => (
                        <FaStar
                            key={starNum}
                            size={24}
                            color={selectedValue >= starNum ? "#FFD700" : "gray"}
                            onClick={() => handleChange({ target: { name: questionId, value: String(starNum) } })}
                            style={{ cursor: "pointer", margin: "0 5px" }}
                        />
                    ))}
                </div>
            </Form>
        )
    }

    {/*render Add comment/feedback*/ }
    if (type == "comment") {
        return (
            <>
                <Form.Control
                    as="textarea"
                    rows={10}
                    style={{ resize: "none", direction: lang === "ar" ? "rtl" : "ltr" }}
                    name={questionId}
                    type="text"
                    placeholder={translate('addComment', lang)}
                    onChange={handleChange}
                    value={answers[questionId] || ''}

                />
            </>
        )
    }

    {/*render checkbox (multi-choices) with/out comment*/ }
    if (type == "checkbox" || type === "hybrid-checkbox") {
        return (
            <>
                {options.map((option, index) => (
                    <div
                        key={index}
                        className="d-flex justify-content-between align-items-center p-3 gap-3 mb-2"
                        style={{
                            backgroundColor: "#eceaea",
                            borderRadius: "4px",
                            direction: lang === "ar" ? "rtl" : "ltr",
                        }}
                    >
                        <Form.Check.Label className="fw-bold">{option}</Form.Check.Label>
                        <Form.Check
                            type={"checkbox"}
                            name={`${questionId}`}
                            id={`${questionId}-${index}`}
                            checked={answers[questionId]?.options?.includes(option) || false}
                            onChange={(e) => handleCheckboxChange(e, option)}

                        />
                    </div>
                ))}
                {type === "hybrid-checkbox" && (
                    <Form.Control
                        as="textarea"
                        style={{ width: "100%" }}
                        name={`${questionId}`}
                        placeholder="Add your comments here..."
                        value={answers[questionId]?.comment || ""}
                        onChange={(e) => handleCommentChange(e)}
                    />
                )}
            </>
        )
    }

    {/* Render customOptions or hybrid-customOptions question */ }
    if (type === "customOptions" || type === "hybrid-customOptions") {
        return (
            <div>
                {options.map((option, index) => {
                    const isOther = type === "hybrid-customOptions" && index === options.length - 1;
                    const isSelected = isOther
                        ? answers[questionId]?.startsWith("other-")
                        : answers[questionId] === option;

                    const handleSelect = () => {
                        if (isOther) {
                            handleChange({
                                target: { name: questionId, value: "other-" },
                            });

                            setTimeout(() => {
                                document.getElementById(`textarea-${questionId}`).focus();
                            }, 0);
                        } else {
                            handleChange({
                                target: { name: questionId, value: option },
                            });
                        }
                    };

                    return (
                        <div
                            key={index}
                            className="d-flex justify-content-between align-items-center p-3 gap-3 mb-2"
                            style={{
                                backgroundColor: "#eceaea",
                                borderRadius: "4px",
                                direction: lang === "ar" ? "rtl" : "ltr",
                                cursor: "pointer",
                            }}
                            onClick={handleSelect}   //Make full row clickable
                        >
                            <Form.Check.Label className="fw-bold">{option}</Form.Check.Label>

                            <Form.Check
                                type="radio"
                                id={index}
                                checked={isSelected}
                                onClick={(e) => e.stopPropagation()} //Prevent double trigger
                                onChange={handleSelect}
                            />
                        </div>
                    );
                })}

                {type === "hybrid-customOptions" && (
                    <div
                        className="mt-2"
                        style={{
                            display:
                                answers[questionId]?.startsWith("other-") ? "block" : "none",
                        }}
                    >
                        <Form.Control
                            as="textarea"
                            id={`textarea-${questionId}`}
                            type="text"
                            placeholder="Please specify..."
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: questionId,
                                        value: `other-${e.target.value}`,
                                    },
                                })
                            }
                            value={answers[questionId]?.replace("other-", "") || ""}
                        />
                    </div>
                )}
            </div>
        );
    }



    {/*render scaling question*/ }
    if (type == "scale5" || type == "scale10") {
        const scaleArray = type === "scale5" ? scaleArray5 : scaleArray10;
        return (
            <div className="d-flex justify-content-between align-items-center p-3 gap-3 mb-2">
                {scaleArray.map((option, index) => (
                    <div>
                        <p style={{ color: answers[questionId]?.includes(option) ? Colors.PRM_LIGHT_BLUE : "#000000", }}>{option}</p>
                        <div key={index}
                            style={{
                                backgroundColor: answers[questionId]?.includes(option) ? Colors.PRM_LIGHT_BLUE : "#FFFFFF",
                                border: `1px solid ${answers[questionId]?.includes(option) ? Colors.PRM_LIGHT_BLUE : "#000000"}`,
                                width: "20px",
                                height: "20px",
                                borderRadius: "20px",
                            }}
                            onClick={() => handleChange({ target: { name: questionId, value: scaleArray?.filter((item) => item <= option) } })}
                        >
                        </div>
                    </div>

                ))}


            </div>

        )
    }

    {/*render matrix-scale5 question*/ }
    if (type === "matrix-scale5") {
        // Get labels for current language, fallback to English, then to numbers
        const labels = scaleLabels?.[lang] || scaleLabels?.en || [];
        const hasCustomLabels = labels.some(label => label && label.trim());

        return (
            <div style={{ marginTop: 12 }}>
                {/* Scale header with labels */}
                <div style={{ display: 'flex', alignItems: 'flex-end', padding: '10px 6px', borderBottom: '2px solid #e0e0e0' }}>
                    <div style={{ flex: 2 }}></div>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                        {scaleArray5.map((s, idx) => (
                            <div key={s} style={{ textAlign: 'center', maxWidth: 60 }}>
                                {hasCustomLabels && labels[idx] && (
                                    <div style={{ fontSize: 11, color: '#666', marginBottom: 4, wordWrap: 'break-word' }}>
                                        {labels[idx]}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                {/* Matrix rows */}
                {items?.map((item, rowIndex) => {
                    const itemText = item.text?.[lang] || item.text?.en || '—';
                    const currentValue = answers[questionId]?.[rowIndex];
                    return (
                        <div
                            key={rowIndex}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '12px 6px',
                                borderBottom: '1px solid #f0f0f0',
                                direction: lang === "ar" ? "rtl" : "ltr"
                            }}
                        >
                            <div style={{ flex: 2 }}>
                                <div style={{ fontWeight: 500 }}>{itemText}</div>
                            </div>
                            <div style={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                                {scaleArray5.map((s) => (
                                    <div
                                        key={s}
                                        onClick={() => handleMatrixChange(questionId, rowIndex, s)}
                                        style={{
                                            width: 24,
                                            height: 24,
                                            borderRadius: '50%',
                                            border: `2px solid ${currentValue === s ? Colors.PRM_LIGHT_BLUE : '#ccc'}`,
                                            backgroundColor: currentValue === s ? Colors.PRM_LIGHT_BLUE : '#fff',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

//#endregion

const SurveyQuestion = ({ index, question, answers, handleChange, handleCheckboxChange, handleCommentChange, handleMatrixChange, lang, iataLogo }) => {
    //#region render Full question number+title+content
    return (

        <div className="mt-2">
            {/* Airport Logo */}
            <Row>
                <Col xs={8}> {/* Aligns logo to the right */}

                </Col>
                <Col xs={4}> {/* Aligns logo to the right */}
                    <img src={PRMLogo} alt="logo" style={{ maxWidth: "100px" }} />
                </Col>
            </Row>
            {/*Question number*/}
            <Container style={{ textAlign: "center", direction: lang === "ar" ? "rtl" : "ltr" }}>
                <Row>
                    <Col xs={12}>
                        <p style={{ fontSize: 22, color: Colors.PRM_LIGHT_BLUE, opacity: 0.8 }}>
                            {`${translate('question', lang)} ${index + 1}`}
                        </p>
                    </Col>
                </Row>
            </Container>
            {/*Question Text/title*/}
            <Container style={{ textAlign: "center" }}>
                <Row >
                    <Col xs={12}>
                        <p style={{ fontSize: 18 }}>
                            {`${question.text}`}
                            {question.optional ? (
                                <span style={{ color: '#888', fontSize: 14, marginLeft: 8 }}>
                                    ({translate('optional', lang)})
                                </span>
                            ) : <span style={{ color: "red", fontSize: 20 }}>*</span>}
                        </p>
                    </Col>
                </Row>
                {/*Question content, rating,  multiple choices and comment*/}
                <Row className="mt-3">
                    <Col xs={12}>
                        <QuestionContent
                            type={question.type}
                            questionId={question.questionId}
                            options={question.options}
                            items={question.items}
                            scaleLabels={question.scaleLabels}
                            starsCount={question.starsCount}
                            answers={answers}
                            handleChange={handleChange}
                            lang={lang}
                            handleCheckboxChange={handleCheckboxChange}
                            handleCommentChange={handleCommentChange}
                            handleMatrixChange={handleMatrixChange}
                        />

                    </Col>
                </Row>
            </Container>


        </div>

    )
    //#endregion
}

export default SurveyQuestion;
